import env from "Consts/env";
import { handle498OnClient } from "Helpers/is498";
import { apiSlice } from "../api/apiSlice";

export const paymentApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getListPaymentMethod: builder.query({
			query: () => ({
				url: "/api/fds-payment-methods",
				headers: {
					...env.HEADERS,
				},
				validateStatus: (response) => response.status === 304
					|| (response.status >= 200 && response.status < 300)
				,
			}),
			transformResponse: (response) => {

				// Periksa apakah ada kode status 498
				if (response?.meta?.code && response.meta.code === 498) {

					handle498OnClient(response); // Jalankan handler
					return null; // Atau data default jika login diperlukan

				}

				// Jika bukan 498, teruskan respons normal
				return { status: response?.status ?? response.meta.code, data: response };

			},
			providesTags: ["PaymentMethod"],
		}),
	}),
});

export const {
	useGetListPaymentMethodQuery,
} = paymentApiSlice;
